// extracted by mini-css-extract-plugin
module.exports = {"banner-wrapper":"_9e1425b4d3--banner-wrapper--biUz7"};